export default __webpack_public_path__ + "static/media/viewFile.9148839b.svg";